import { memo, type FC } from 'react'

import {
  Box,
  Fallback,
  border,
  borderRadius,
  colors,
  dimensions,
  shadows,
} from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  src: string
  alt: string
  isHighlighted: boolean
}

const Avatar: FC<Props> = ({ src, alt, isHighlighted }) => {
  const highlightedBoxShadow = `${shadows.s400}, 0 0 0 ${border.width.s6} ${colors.radicalRed800}`

  return src ? (
    <img
      alt={alt}
      src={buildUrl(src)}
      style={{
        width: dimensions.s80,
        height: dimensions.s80,
        borderRadius: borderRadius.rel333,
        boxShadow: isHighlighted ? highlightedBoxShadow : undefined,
      }}
    />
  ) : (
    <Box
      width="s80"
      height="s80"
      borderRadius={{ all: 'rel333' }}
      style={{ boxShadow: isHighlighted ? highlightedBoxShadow : undefined }}
    >
      <Fallback label={alt} />
    </Box>
  )
}

export default memo(Avatar)
